import React from "react";

function CaterTable({ caters, onDeleteCater }) {
  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-semibold text-slate-900">Cater List</h2>
        <div className="text-sm text-slate-500">
          Total: {caters.length}
        </div>
      </div>

      {caters.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 p-8 text-center text-slate-500">
          No cater records found.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[1200px] text-sm">
            <thead>
              <tr className="text-left text-slate-500 border-b">
                <th className="py-3">Cater Name</th>
                <th className="py-3">Address</th>
                <th className="py-3">Owner Name</th>
                <th className="py-3">Owner Number</th>
                <th className="py-3">Employee Name</th>
                <th className="py-3">Employee Number</th>
                <th className="py-3">Per Day Food Cost</th>
                <th className="py-3">Email</th>
                <th className="py-3">Created At</th>
                <th className="py-3">Action</th>
              </tr>
            </thead>
            <tbody>
              {caters.map((cater) => (
                <tr key={cater.id} className="border-b last:border-0">
                  <td className="py-4 font-medium text-slate-900">{cater.caterName}</td>
                  <td className="py-4">{cater.caterAddress}</td>
                  <td className="py-4">{cater.ownerName}</td>
                  <td className="py-4">{cater.ownerNumber}</td>
                  <td className="py-4">{cater.employeeName}</td>
                  <td className="py-4">{cater.employeeNumber}</td>
                  <td className="py-4">₹{cater.perDayFoodCost}</td>
                  <td className="py-4">{cater.email || "-"}</td>
                  <td className="py-4">{cater.createdAt}</td>
                  <td className="py-4">
                    <button
                      onClick={() => onDeleteCater(cater.id)}
                      className="rounded-lg bg-red-50 text-red-600 px-3 py-2 text-xs font-medium hover:bg-red-100"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default CaterTable;